export interface ProductBundleModuleDetails {
  name: string;
  altName: string;
  image: string;
  description: string;
  bundles: string[];
}
